import getBasePath from '../functions/api-resource';

const basePath = getBasePath('api', 'orcamento-verba-investimento');

const orcamentoVerbaInvestimentoActions = {
  acaoConfiguracaoInvestimento: { method: 'GET', url: `${basePath}/{id}/acao-configuracao-investimento` },
};

export default (resource) => resource(`${basePath}`, {}, orcamentoVerbaInvestimentoActions);
